import React, { useContext, useEffect, useState } from "react";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import { PortalContext } from "../../context/Provider";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import Loading from "../../components/Genericos/Loading/Loading";
import { GlobalContext } from "../../../global/context/Provider";
import {
  BodyMisCertificados,
  CardCertificadoMotion,
  CardsCertificadoBox,
  CardsCertificadoBoxMotion,
  CertificadoContainerMotion,
  LineaSeparadora,
} from "./localStyle";
import Tooltip from "global/component/Genericos/Tooltip/Tooltip";
import PdfIcon from "_+_Portal/assets/images/generico/PdfIcon";
import DescargarIcon from "_+_Portal/assets/images/generico/DescargarIcon";
import { hideModal, showModal } from "_+_Portal/context/Actions/modal/modal";
import {
  certificadosReset,
  wsGetMisCertificados,
  wsGetCertificadoPdf,
} from "_+_Portal/context/Actions/certificado/certificado";
import { showToaster } from "global/context/action/toaster/toaster";
import { getStrDateYear } from "global/utils/diasData";
import { detectarIOS } from "global/utils/detectarIOS";
import { base64toBlob } from "global/utils/base64toBlob";
import { Device } from "@capacitor/device";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { FileOpener } from "@capacitor-community/file-opener";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import camelize from "global/utils/camelize";
import TurnoNoEncontrado from "_+_Portal/components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";
import { isMobile } from "global/utils/platformDetector";
import FloatingScroll from "_+_Portal/components/Genericos/FloatingScroll/FloatingScroll";
import { container, dots, pageContainerVariants } from "global/utils/cardAnimation";
import HeaderTitle from "_+_Portal/components/Genericos/HeaderTitle/HeaderTitle";

const MisCertificados = () => {
  const {
    certificadoState,
    modalDispatch,
    certificadoDispatch,
  } = useContext(PortalContext);
  const { toasterState, toasterDispatch } = useContext(GlobalContext);
  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const [certificadosData, setCertificadosData] = useState([]);
  const [loadingPdf, setLoadingPdf] = useState(false);

  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  const downloadiOSFileNative = (b64Data, fileName) => {
    Filesystem.writeFile({
      path: fileName,
      data: b64Data,
      directory: Directory.Documents,
    }).then((c) => {
      try {
        FileOpener.open({
          filePath: c.uri,
          contentType: "application/pdf",
          openWithDefault: true,
        });
      } catch (e) {
        console.log("Error opening file", e);
      }
    });
  };

  const currentDate = new Date().toLocaleString().replace(/[,:\s\/]/g, "-");

  const downloadPdfAndroidNative = (b64Data) => {
    const fileName = `Certificado-${currentDate}.pdf`;
    Filesystem.writeFile({
      path: `Download/${fileName}`,
      data: b64Data,
      directory: Directory.ExternalStorage,
    }).then((c) => {
      try {
        FileOpener.open({
          filePath: c.uri,
          contentType: "application/pdf",
          openWithDefault: true,
        });
      } catch (e) {
        console.log("Error opening file", e);
      }
    });
  };

  // Certificado emitido via RCTA: abre el PDF firmado directo desde el link S3
  // (patron CardOrdenDigital.verOrden). Devuelve true si lo manejo por link.
  const abrirLinkRcta = async (item) => {
    if (
      !item?.linkPdfRcta ||
      typeof item.linkPdfRcta !== "string" ||
      item.linkPdfRcta.trim() === ""
    ) {
      return false;
    }
    try {
      if (Capacitor.isNativePlatform()) {
        await Browser.open({ url: item.linkPdfRcta });
      } else {
        window.open(item.linkPdfRcta, "_blank");
      }
    } catch (error) {
      console.error("Error al abrir la URL:", error);
      showToaster(
        {
          texto: "Error al abrir el documento",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
    return true;
  };

  const visualizarCertificado = async (item) => {
    if (await abrirLinkRcta(item)) return;
    setLoadingPdf(true);
    wsGetCertificadoPdf(item.id, (isCorrect, data) => {
      setLoadingPdf(false);
      if (isCorrect && data?.pdfBase64) {
        showModal(
          "Genericos/InformePDF/RecetaPDF",
          {
            titulo: `Certificado - ${camelize(item.tipoCertificadoDescripcion)}`,
            dissmiss: dissmiss,
            pdf: data.pdfBase64,
          },
          [],
          "centro",
          true
        )(modalDispatch);
      } else {
        showToaster(
          {
            texto: data?.errorMessage || "Error al obtener el PDF del certificado.",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    })(certificadoDispatch);
  };

  const descargarCertificado = async (item) => {
    if (await abrirLinkRcta(item)) return;
    setLoadingPdf(true);
    wsGetCertificadoPdf(item.id, (isCorrect, data) => {
      setLoadingPdf(false);
      if (!isCorrect || !data?.pdfBase64) {
        showToaster(
          {
            texto: data?.errorMessage || "Error al obtener el PDF del certificado.",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        return;
      }

      const b64Data = data.pdfBase64;
      const fileName = `Certificado-${item.id}.pdf`;
      const isIOS = detectarIOS();

      if (isIOS) {
        Device.getInfo().then((info) => {
          if (info.platform === "web") {
            const blob = base64toBlob(b64Data, "data:application/pdf");
            const blobUrl = URL.createObjectURL(blob);
            const descarga = document.createElement("a");
            descarga.href = blobUrl;
            descarga.target = "_blank";
            descarga.download = fileName;
            document.body.appendChild(descarga);
            descarga.click();
            document.body.removeChild(descarga);
          } else {
            downloadiOSFileNative(b64Data, fileName);
          }
        });
      } else {
        Device.getInfo().then((info) => {
          if (info.platform === "web") {
            const descarga = document.createElement("a");
            descarga.href = `data:application/pdf;base64,${b64Data}`;
            descarga.target = "_blank";
            descarga.download = fileName;
            document.body.appendChild(descarga);
            descarga.click();
          } else {
            downloadPdfAndroidNative(b64Data);
          }
        });
      }
    })(certificadoDispatch);
  };

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const limpiarCertificados = () => {
    certificadosReset()(certificadoDispatch);
  };

  const cargarCertificados = (isCorrect, data) => {
    if (isCorrect) {
      setCertificadosData(data?.certificados || []);
    } else {
      showToaster(
        {
          texto: data?.errorMessage || "Error al cargar los certificados.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  useEffect(() => {
    wsGetMisCertificados(cargarCertificados)(certificadoDispatch);
  }, []);

  return (
    <React.Fragment>
      {toasterState.toaster.show && <ToasterV2 />}
      <Loading
        dataLoading={certificadoState.certificados.loading || loadingPdf}
        color="c-white"
        descripcion={
          certificadoState.certificados.loading
            ? "Cargando Certificados..."
            : loadingPdf
            ? "Obteniendo PDF..."
            : ""
        }
      />
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
        nextFnc={limpiarCertificados}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <HeaderTitle title={"Ver Certificados"} />
      <BodyMisCertificados className="ptur-bodyContainer-misCertificados">
        <Sidebar nextFnc={limpiarCertificados} />
        <CertificadoContainerMotion
          variants={pageContainerVariants(esMobile)}
          initial="hidden"
          animate="visible"
          exit="exit"
          className={"ptur-misCertificados-boxGrid"}
        >
          <p className="rb24b ptur-misCertificados-tituloPagina">
            Visualizá y descargá tus certificados médicos
          </p>
          <hr className="ptur-misMedicos-lineaSeparadora" />
          <CardsCertificadoBoxMotion
            key={certificadosData?.length}
            variants={container(0.1)}
            initial="hidden"
            animate="visible"
            $empty={certificadosData?.length === 0}
          >
            {!certificadoState.certificados.loading && (
              <CardsCertificadoBox>
                {certificadosData.length > 0 ? (
                  certificadosData.map((item) => (
                    <CardCertificadoMotion
                      key={item.id}
                      className="itemCardCertificado"
                      variants={dots()}
                    >
                      <p className="rb18m c-white tituloCard">
                        Emitido: {getStrDateYear(new Date(item.fechaAlta))}
                      </p>
                      <div className="bodyCard">
                        <p className="rb16l">
                          Tipo:{" "}
                          <span className="rb16m">
                            {camelize(item.tipoCertificadoDescripcion)}
                          </span>
                        </p>
                        <p className="rb16l">
                          Médico:{" "}
                          <span className="rb16m">
                            {camelize(item.medicoDescripcion)}
                          </span>
                        </p>
                        <p className="rb16l">
                          Especialidad:{" "}
                          <span className="rb16m">
                            {camelize(item.especialidadDescripcion)}
                          </span>
                        </p>
                        <LineaSeparadora />
                        <div className="iconContainer">
                          <Tooltip
                            customCss={"certificadoTooltip"}
                            descripcion={"Descargar Certificado"}
                            data={
                              <div
                                className="ptur-misLaboratorios-iconoDescargar"
                                onClick={() => descargarCertificado(item)}
                              >
                                <DescargarIcon
                                  color={"#006199"}
                                  width={20}
                                  height={20}
                                />
                              </div>
                            }
                          />
                          {!isMobile && (
                            <Tooltip
                              customCss={"certificadoTooltip"}
                              descripcion={"Ver Certificado"}
                              data={
                                <div
                                  className="ptur-misLaboratorios-iconoDescargar"
                                  onClick={() => visualizarCertificado(item)}
                                >
                                  <PdfIcon
                                    color={"#006199"}
                                    width={20}
                                    height={20}
                                  />
                                </div>
                              }
                            />
                          )}
                        </div>
                      </div>
                    </CardCertificadoMotion>
                  ))
                ) : (
                  <TurnoNoEncontrado
                    state={certificadosData}
                    loadingState={false}
                    texto={"No se encuentran registros de certificados."}
                    txtBtn="Buscar un turno"
                    showBtn={false}
                  />
                )}
              </CardsCertificadoBox>
            )}
          </CardsCertificadoBoxMotion>
        </CertificadoContainerMotion>
        <FloatingScroll body={"ptur-misCertificados-boxGrid"} />
      </BodyMisCertificados>
    </React.Fragment>
  );
};

export default MisCertificados;
